<template>
    <v-container fluid :class="{'pa-0': $vuetify.breakpoint.smAndUp}">
        <v-row class="pa-0 mt-n2 mb-3" v-show="!$vuetify.breakpoint.smAndUp">
            <v-col class="py-0">
                <div class="headline" style="font-size: 1.2rem !important">{{event && event.name}}</div>
            </v-col>
        </v-row>
        <v-tabs v-model="activeTab" :vertical="$vuetify.breakpoint.smAndUp" show-arrows @change="scrollToTop">
            <v-tab v-for="tab in eventTabs" :key="tab" :to="'/event/' + $route.params.eventId + '/' + tab" :style="tab === 'guest' ? 'background-color: #f5f5f5' : ''" ripple>
                <div :style="'white-space: pre-line; line-height: 21px;'">
                    <span
                        v-if="
                            tab === 'iframe' &&
                            (event && (event.id === 'a0711058-fc9a-4bd2-9a22-4886810ab3bb' || event.id === 'e96ab950-e3d6-4b52-917d-3fcc00614735'))
                        "
                    >Delegate<br>Approval</span>
                    <span v-else>{{$t('event.'+tab)}}</span>
                </div>
            </v-tab>
            <v-tab-item v-for="tab in eventTabs" :key="tab" :id="'/event/'+$route.params.eventId+'/'+tab" style="height: 100%;">
                <router-view v-if="activeTab === '/event/'+$route.params.eventId+'/'+tab" :companyId="companyId"></router-view>
            </v-tab-item>
        </v-tabs>
    </v-container>
</template>

<script>
    import {computed, ref, watch} from '@vue/composition-api'
    import {useGet, useFind} from "feathers-vuex";
    import eConfig from "../../evention-config";

    export default {
        name: 'EventDetail',
        components: {},

        setup(props, {root}) {
            const {Event, Company, EventCmsTab} = root.$FeathersVuex.api;
            
            const eventId = computed(() => root.$route.params.eventId);
            const {item: event} = useGet({model: Event, id: eventId.value});
            
            const companyId = computed(() => (event.value && event.value.companyId));
            const {item: company} = useGet({model: Company, id: companyId.value});

            const eventCmsTabParams = computed(() => {
                return {
                    query: {
                        eventId: eventId.value
                    }
                }
            });
            const {items: eventCmsTabList, isPending: isFindEventCmsTabPending} = useFind({model: EventCmsTab, params: eventCmsTabParams});
            const eventCmsTabData = ref();
            watch(isFindEventCmsTabPending, (newVal, oldVal) => {
                if (!newVal && oldVal) {
                    if (eventCmsTabList.value.length > 0) {
                        eventCmsTabData.value = eventCmsTabList.value[0]
                    }
                }
            })

            const defaultTabList = [
                'guest',
                'merchant',
                'details',
                'cms-tabs',
                'features',
                'layouts',
                'colors',
                'home',
                'icon',
                'profile',
                'about',
                'agenda',
                'restaurant',
                'news',
                'speaker',
                'galleries',
                'notifications',
                'notification-groups',
                // 'single-notification',
                'sponsor',
                'report',
                'faq',
                'general',
                'room',
                'promo-code',
                'document',
                'evoucher',
                'transport',
                'flight',
                'useful-information',
                'iframe'
            ]
            const activeTab = ref(0);
            const eventTabs = ref([]);
            const canUpdateTab = computed(() => {
                return (root.$store.state.auth.user && !isFindEventCmsTabPending.value);
            });
            const isSuperAdmin = computed(() => {
                return (root.$store.state.auth.user && root.$store.state.auth.user.permissions === eConfig.user.permission.super);
            });
            watch(canUpdateTab, (newVal, oldVal) => {
                if (newVal) {
                    if (isSuperAdmin.value) {
                        eventTabs.value = defaultTabList
                    } else {
                        if (!eventCmsTabData.value) {
                            eventTabs.value = defaultTabList.filter((tab) => tab != 'cms-tabs')
                        } else {
                            eventTabs.value = Object.keys(eventCmsTabData.value).filter((k) => {
                                return eventCmsTabData.value[k] && (!['id', 'eventId', 'createdAt', 'updatedAt'].includes(k))
                            })
                        }
                    }
                }
            })
            
            watch(event, (event) => {
                if (event && document.querySelector('#event-name')) {
                    document.querySelector('#event-name').innerHTML = ' &#187; ' + event.name;
                }
            });
            
            watch(companyId, (companyId) => {
                if (companyId) root.$store.commit('setPrefilledCompanyId', companyId);
            });
            
            const scrollToTop = () => {
                if (root.$vuetify.breakpoint.smAndUp) window.scrollTo({top: 0, left: 0, ehavior: 'smooth'});
            }

            return { 
                event,
                company,
                companyId,
                activeTab,
                eventTabs,
                scrollToTop,
            }
        },
    }
</script>